module.exports = __webpack_public_path__ + "static/img/editor-type4.143ea84c.png";